import { render, staticRenderFns } from "./myCenter.vue?vue&type=template&id=7b5e3544&scoped=true&"
import script from "./myCenter.vue?vue&type=script&lang=js&"
export * from "./myCenter.vue?vue&type=script&lang=js&"
import style0 from "./myCenter.vue?vue&type=style&index=0&id=7b5e3544&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/.store/vue-loader@15.10.0/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b5e3544",
  null
  
)

export default component.exports